import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import BulkMessages from "./bulk-messages";
import Client from "./Client";
import Selects from "./selects";
import Header from "./header";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import AiClientsCount from "./AiClientsCount";
import getKhattabat101CGeneralStore from "../../../stores/khattabat-stores/101c-stores/101c-general-store";
import getKhattabatBulkMessagingStore from "../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";

const KhattabatClients = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const clients = getKhattabat101CGeneralStore().getClients.get();
  getKhattabatBulkMessagingStore().initializeInputFields();
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1520}
      height={0}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Header />
      {isAiKhattaba ? <AiClientsCount /> : <Selects />}
      <Et3Margin top={50} bottom={50} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={1520}
        height={0}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {clients.map((userID) => {
          return <Client key={userID} userID={userID} />;
        })}
      </ET3Div>
      <BulkMessages conversationType="101C" />
    </ET3Div>
  );
});
export default KhattabatClients;
